<template>
  <div class="fs-textinput" :style="wrapperStyle" v-show="show" @click.self="clickBG">
    <div class="fs-form" @click.stop="">
      <!-- 文字框上面的訊息 -->
      <slot></slot>
      <textarea class="fs-textarea" v-if="show" v-model="tmpInput" :placeholder="placeholder"></textarea>
      <div class="fs-form-control">
        <button class="fs-btn fs-btn-submit" @click="submit()">
          送出
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    top: {
      type: Number,
      required: true
    },
    left: {
      type: Number,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: '#222A'
    },
    // show / hide
    show: {
      type: Boolean,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    cancellable: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    show (s) {
      // 打開時同步
      if (s) {
        this.tmpInput = this.value
      }
    }
  },
  data () {
    return {
      tmpInput: ''
    }
  },
  computed: {
    screen () {
      const { height, width } = this.$store.state.screen
      return {
        height: height - 1,
        width
      }
    },
    wrapperRect () {
      const top = this.top == null ? 0 : this.top
      const left = this.left == null ? 0 : this.left
      const height = this.height == null ? 0 : this.height
      const width = this.width == null ? 0 : this.width
      return {
        top,
        left,
        height,
        width
      }
    },
    wrapperStyle () {
      const { top, left, height, width } = this.wrapperRect
      const { background } = this
      return {
        background,
        top: top + 'px',
        left: left + 'px',
        height: height + 'px',
        width: width + 'px'
      }
    }
  },
  methods: {
    clickBG (e) {
      console.log('this.cancellable', this.cancellable)
      if (this.cancellable) {
        this.close()
      }
    },
    submit () {
      this.$emit('input', this.tmpInput)
      if (this.tmpInput !== this.value) {
        this.$emit('change', this.tmpInput)
      }
      this.$emit('submit', this.tmpInput)
      this.close()
    },
    close () {
      this.$emit('update:show', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.fs-textinput{
  position: absolute;
  box-sizing: border-box;
  .fs-form{
    position: absolute;
    top: 10%;
    padding: 5% 5% 5% 5%;
    width: 100%;
  }
  .fs-textarea{
    resize: none;
    background-color: #DEDEDE;
    width: 100%;
    height: 135px;
    max-height: 30%;
    border-radius: 6px;
    padding: 8px;
  }
  ::placeholder {
    color: #817E7E;
  }
  .fs-form-control{
    text-align: center;
  }
  .fs-btn{
    display: inline-block;
    padding: 4px 35px 4px 35px;
  }
  .fs-btn-submit{
    background-color: #E57A7A;
    color: white;
    border-radius: 6px;
  }
}

</style>
